import {IBoosterPagesCompressed} from "../../../../../../store/reducers/booster.reducer";

export class BoosterPagesCompressed implements IBoosterPagesCompressed {
  pageId: number;
  url?: string;
  imagesCount: number;

  constructor(stats, pageUrl?) {
    this.pageId = stats.page_id;
    this.url = pageUrl || null;
    this.imagesCount = stats.images_count;
  }
}
